import { render, staticRenderFns } from "./RestoreBackupModal.vue?vue&type=template&id=786f38d5"
import script from "./RestoreBackupModal.vue?vue&type=script&lang=ts"
export * from "./RestoreBackupModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('786f38d5')) {
      api.createRecord('786f38d5', component.options)
    } else {
      api.reload('786f38d5', component.options)
    }
    module.hot.accept("./RestoreBackupModal.vue?vue&type=template&id=786f38d5", function () {
      api.rerender('786f38d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-default/RestoreBackupModal.vue"
export default component.exports